import DisasterAreasService from '../../disaster-areas-service'
import lodash from 'lodash'

export default {
  data() {
    return {
      name: null,
      description: null,
      disasterTypeId: null,
      disasterSubTypeId: null
    }
  },
  props: {
    polygonLayer: {
      type: Object,
      required: true
    },
    disasterTypes: {
      type: Array,
      required: true
    },
    disasterSubTypes: {
      type: Array,
      required: true
    }
  },
  created() {
    let polygonData = this.polygonLayer.toGeoJSON()
    polygonData.properties = polygonData.properties || {}
    this.name = polygonData.properties.name
    this.description = polygonData.properties.description
    this.disasterTypeId = polygonData.properties.d_type_id
    this.disasterSubTypeId = polygonData.properties.ds_type_id

    this.$nextTick(() => {
      this.$refs.name.focus()
      this.showInfo(this.$t('disasterAvoidPolygons.fillAreaProperties'))
    })
  },
  computed: {
    getDisasterTypes () {
      return this.disasterTypes
    },
    getDisasterSubtypes () {
      if (!this.disasterTypeId) {
        return []
      }
      var parentId = this.disasterTypeId
      let subTypes =  lodash.filter(this.disasterSubTypes, (d) => {
        return d.parent_id === parentId
      })
      return subTypes
    },
    readOnlyMode () {
      return !this.$store.getters.authorizationKey
    }
  },
  methods: {
    /**
     * Handle the save btn click. Validate the form,
     * build a polygon model and save it via api
     */
    save () {
      if (!this.name || !this.description || !this.disasterTypeId) {
        this.showError(this.$t('disasterAvoidPolygons.fillRequiredFields'))
      } else {
        let polygonGeoJson = this.polygonLayer.toGeoJSON()
        let polygonModel = this.buildPolygonModel(polygonGeoJson)

        let context = this
        polygonModel.$save().then(response => {
          polygonGeoJson.properties.id = response.resource.id
          context.setAvoidPolygonProperties(context.polygonLayer, polygonGeoJson)
          context.showSuccess(context.$t('disasterAvoidPolygons.avoidAreaSaved'))
          context.polygonLayer.closePopup()
          context.$emit('saved')
        }).catch(response => {
          if (response.status && response.status === 401) {
            context.showError(context.$t('disasterAvoidPolygons.authorizationError'))
          } else {
            if (response.data && response.data.code) {
              let errorTranslationKey = `disasterAvoidPolygons.errorCodes.${response.data.code}`
              context.showError(context.$t(errorTranslationKey))
            } else {
              console.log(response)
              context.showError(context.$t('disasterAvoidPolygons.errorWhileTryingToSaveDisasterArea'))
            }
          }
        })
      }
    },
    /**
     * Build polygon active record model
     * @param {*} polygonGeoJson
     * @returns {VueRestClient/Model}
     */
    buildPolygonModel (polygonGeoJson) {
      // Remove unwanted properties
      delete polygonGeoJson.properties.avoidPolygon

      polygonGeoJson.properties.name = this.name
      polygonGeoJson.properties.description = this.description
      polygonGeoJson.properties.d_type_id = this.disasterTypeId
      polygonGeoJson.properties.ds_type_id = this.disasterSubTypeId
      polygonGeoJson.properties.provider_id = this.$store.getters.providerId

      let polygonModel = DisasterAreasService.newModelInstance(polygonGeoJson)

      // geojson objects don't store id in the root, but in properties
      // so we have to restore it from properties
      polygonModel.id = polygonModel.properties.id
      return polygonModel
    },
    setAvoidPolygonProperties (polygon, polygonData = null) {
      // define polygon feature prop.
      // It will be returned when we get the geojson
      // representation of the polygon
      polygon.feature = polygon.feature || {}
      polygon.feature.type = polygon.feature.type || 'Feature'
      polygon.feature.properties = polygon.feature.properties || {}
      polygon.feature.properties.avoidPolygon = true

      // Append the properties from polygon data
      if (polygonData && polygonData.properties) {
        for (let key in polygonData.properties) {
          polygon.feature.properties[key] = polygonData.properties[key]
        }
      }
    },
    cancel () {
      this.$emit('cancel')
    }
  },
}
